import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {NewRegistrationTermsPage} from './new-registration-terms';

@NgModule({
  declarations: [
    NewRegistrationTermsPage,
  ],
  imports: [
    IonicPageModule.forChild(NewRegistrationTermsPage),
  ],
  exports: [
    NewRegistrationTermsPage
  ]
})
export class NewRegistrationTermsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/new-registration-terms/new-registration-terms.module.ts